import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import CenteredOpacityContainer from "@/components/Shared/CenteredOpacityContainer";
import CustomLink from "@/components/Buttons/CustomLink";
import localizePath from "@/functions/localizePath";
import useLocale from "@/hooks/useLocale";
import teamImg from "@/assets/about/team.png";

import imagesMetaData from "@/../.sourceflow/image_metadata.json";

export default function AboutPagePeople() {
  const locale = useLocale();

  return (
    <div className="bg-white pt-20 md:pt-[137px]">
      <div className="container">
        <div className="flex justify-between flex-col lg:flex-row gap-10 lg:gap-0">
          <h2 className="text-3xl sm:leading-[50px] sm:text-[40px] xl:text-[50px]/[60px] text-purple max-w-[628px] 2xl:max-w-none w-full md:pe-[50px]">
            <CustomSourceFlowText
              title="Our people are what make us special"
              path="dynamic1.about.special"
              locale={locale}
            />
            <span className="text-pink">.</span>
          </h2>
          <div className="flex flex-col max-w-[540px] 2xl:max-w-none w-full gap-8">
            <span className="text-xl/8 text-purple">
              <CustomSourceFlowText
                title=" We’ve been helping clients achieve the results they need for over 20 years. In that time, we’ve refined ou. We’ve been helping clients achieve the results they need for over 20 years. In that time, we’ve refined ou."
                path="dynamic1.about.desc"
                locale={locale}
              />
            </span>
            <CustomLink
              href={localizePath("/team", locale)}
              color="purple"
              styles="text-xl text-center w-max"
            >
              <CustomSourceFlowText
                title="Meet the team"
                path="dynamic1.about.meetteam"
                locale={locale}
              />
            </CustomLink>
          </div>
        </div>
        <div className="w-full h-full py-10 sm:py-[55px]">
          <SourceFlowImage
            imagesMetaData={imagesMetaData}
            path="about_page.people"
            src={teamImg ?? ""}
            alt="team"
            size="1366x"
            className="max-w-[1264px] w-full min-h-[300px] sm:min-h-max 2xl:max-w-none sm:max-h-[538px] h-full object-cover"
          />
        </div>
      </div>
      <CenteredOpacityContainer
        content={{
          title: "Diversity and inclusion is part of our dna",
          content:
            "We’ve been helping clients achieve the results they need for over 20 years. In that time, we’ve refined ou. We’ve been helping.",
          link: {
            txt: "Learn more",
            href: localizePath("/csr", locale),
          },
          people: true,
        }}
        path="about"
      />
    </div>
  );
}
